import React, { useState } from 'react';

// Kelly's celebration photos for agents. Files live in public/celebrations/.
// Add or remove entries here; one is picked at random each time the card appears.
export const CELEBRATION_PHOTOS = [
  '/celebrations/celebration-1.jpg',
  '/celebrations/celebration-2.jpg',
];

// The photo speaks for itself, so no caption is shown. The message prop is kept for later use.
export default function CelebrationCard() {
  const [photo] = useState(() => (
    CELEBRATION_PHOTOS.length
      ? CELEBRATION_PHOTOS[Math.floor(Math.random() * CELEBRATION_PHOTOS.length)]
      : ''
  ));

  return (
    <div style={{ background: '#ffffff', borderRadius: '10px', padding: '20px', width: 240, flexShrink: 0, textAlign: 'center', boxSizing: 'border-box' }}>
      {photo ? (
        <img src={photo} alt="Congratulations" style={{ width: '100%', maxWidth: 200, borderRadius: '10px', objectFit: 'cover', border: '2px solid #D4AF37' }} />
      ) : null}
    </div>
  );
}
